import _ from 'underscore';

export default class Mills {
  constructor($scope, $rootScope, MillService, PaginationService) {
    $scope.load_data = function() {
      $scope.loading = true;
      MillService.get($scope.filter).success(function(data) {
        $scope.mills = data.mills;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
        if ($scope.selected_mills) {
          _.each($scope.selected_sources, function(mill_id) {
            var mill = _.findWhere($scope.mills, {
              id: mill_id
            });
            if (mill)
              mill.checked = true;
          });
        }
        $scope.loading = false;
      });
    };
    
    $scope.init_filter = function() {
      $scope.filter = {
        page: 1,
        per_page: 40
      };
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.load_data();
    };

    $scope.quick_search = function() {
      window.filter_table('table.data', $scope.quick_filter);
    };
    
    
    $scope.init = function() {
      $scope.mills = [];
      $scope.pagination = {};
      $scope.init_filter();
      $scope.load_data();
    };

    $scope.init();

  }
}

Mills.$inject = ['$scope', '$rootScope', 'MillService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/mills.ctrl.js